import i18n from 'src/i18n'

export class MathHelper {
  static lestCommonMultiple = (a: number, b: number) => {
    return (a * b) / MathHelper.greatestCommonDivisor(a, b)
  }

  static greatestCommonDivisor = (a: number, b: number) => {
    let temporal
    while (b !== 0) {
      temporal = b
      b = a % b
      a = temporal
    }
    return a
  }

  static lestCommonMultipleArray = (array: number[]) => {
    if (array.length) {
      return array.reduce((a, b) => MathHelper.lestCommonMultiple(a, b))
    }
  }

  static greatestCommonDivisorArray = (array: number[]) => {
    if (array.length) {
      return array.reduce((a, b) => MathHelper.greatestCommonDivisor(a, b))
    }
  }

  static round(num: number, decimals?: number) {
    const factor = Math.pow(10, decimals || 0)
    return Math.round(num * factor) / factor
  }

  static roundNumber(num: number, decimals?: number) {
    return i18n.n(num, { maximumFractionDigits: decimals })
  }

  static convertM2ToHa = (m2: number) => {
    return m2 / 10000
  }

  static adjustToLimits = (value: number, min: number, max: number) => {
    if (value < min) {
      return min
    }
    if (value > max) {
      return max
    }
    return value
  }
}
